export default __webpack_public_path__ + "static/media/pushtheboat_logo.cbcbd6f2.svg";